import { render, staticRenderFns } from "./ProductDefault.vue?vue&type=template&id=1141deb9&lang=html"
import script from "./ProductDefault.vue?vue&type=script&lang=js"
export * from "./ProductDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports